<template>
  <v-card outlined :to="link">
    <v-card-text>
      <v-row dense>
        <v-col cols="auto">
          <v-icon :color="item.used ? 'success' : 'error'">
            {{ item.used ? "check_circle" : "cancel" }}
          </v-icon>
        </v-col>
        <v-col class="font-weight-medium subtitle-1 secondary--text">
          {{ name }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import features from "@/helpers/mixins/features";
export default {
  name: "UsageOverallCard",
  mixins: [features],
  props: { item: { type: Object } },
  computed: {
    name() {
      return this.getFeatureName(this.item.featureId);
    },
    link() {
      return this.getFeatureReportLink(this.item.featureId);
    }
  }
};
</script>
